import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstace from "src/utilities/axios";

let initialState = {
  isLoading: false,
  data: {},
  error: null,
}

export const getBlogsHeader = createAsyncThunk(
  "blogsHeader/getBlogsHeader",
  async (_, thunkApi) => {
    try {
      const { data } = await axiosInstace.get("/blogs/header");
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateBlogsHeader = createAsyncThunk(
  "blogsHeader/updateBlogsHeader",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstace.put("/blogs/header", args);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const blogsHeaderSlice = createSlice({
  name: "blogsHeader",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getBlogsHeader.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBlogsHeader.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data || {};
        state.error = null;
      })
      .addCase(getBlogsHeader.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload.error;
      })

      .addCase(updateBlogsHeader.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateBlogsHeader.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data || {};
        state.error = null;
      })
      .addCase(updateBlogsHeader.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload.error;
      })
  }
});

export default blogsHeaderSlice.reducer;